<template>
  <div class="flex h-full">
    <SideBar :activeComponent="activeComponent" :class="{'w-56': openMenu}" class="w-12 z-10 sm:w-64 fixed"></SideBar>
    <div :class="{'w-56': openMenu}" class=" w-12 sm:w-64  fixed z-0 h-full"
         style=" background: linear-gradient(180deg, #722ded 0%, #a67bf4 100%);">

    </div>
    <div :class="{'ml-56': openMenu,'translate-x-56':openMenu}" class="w-full sm:p-4 ml-12 sm:ml-64">

      <TopBar class="mb-2 sm:mb-4"></TopBar>
      <div class="flex w-full">
        <component :is="activeComponent"/>
      </div>
    </div>
  </div>
</template>

<script>

  import SideBar from "./SideBar";
  import TopBar from "./TopBar";
  import ContentMain from "./States/StateIndexContent";
  import {eventBus} from '../eventbus';
  import IsolationIndex from "./isolations/IsolationIndex";
  import AreaAffectedIndex from "./affected_areas/AreaAffectedIndex";
  import NumberIndex from "./numbers/NumberIndex";
  import Settings from "./Settings";
  import TestIndex from "./test_centers/TestIndex";
  import BlogIndex from "./blog/BlogIndex";


  export default {
    name: "Main",
    components: {
      SideBar,
      TopBar,
      ContentMain,
      IsolationIndex,
      AreaAffectedIndex,
      NumberIndex,
      Settings,
      TestIndex,
      BlogIndex
    },
    data: () => ({
      activeComponent: 'ContentMain',
      openMenu: false

    }),
    methods: {
      listener() {
        eventBus.$on('State', () => this.activeComponent = "ContentMain")
        eventBus.$on('Isolation', () => this.activeComponent = "IsolationIndex")
        eventBus.$on('Numbers', () => this.activeComponent = "NumberIndex")
        eventBus.$on('Settings', () => this.activeComponent = "Settings")
        eventBus.$on('AffectedAreas', () => this.activeComponent = "AreaAffectedIndex")
        eventBus.$on('Test', () => this.activeComponent = "TestIndex")
        eventBus.$on('Blog', () => this.activeComponent = "BlogIndex")
      }
    },
    created() {
      this.listener()
    },

  }
</script>

<style scoped>
</style>
